<span [class]="status" class="color-dot"> </span>
